// Simple version of zip that pairs elements to the end of the first array.
// Assumes all arrays are at least as long as the first array.
export function zip([first = [], ...rest]: any[][]): any[][] {
  return first.map((element, index) => {
    return [element, ...rest.map((nth) => nth[index])]
  })
}
